import Faq from '../../components/LandingPage/Faq'
import WebsiteLayout from '../../components/LandingPageWrapper'

const FaqPage = () => {
  return (
    <WebsiteLayout>
      <Faq />
    </WebsiteLayout>
  )
}

export default FaqPage
